import {isSketchRelationContainer} from '../SketchRelationContainer';
import type {SketchRelationDefinition} from '../relationDefinition/SketchRelationDefinition';

/**
 * 将一条逻辑关系从全部目标宿主中永久解除。
 *
 * 该入口只用于用户删除关系、实体级联删除和对象销毁等最终生命周期；临时预览或
 * 历史采集不得调用。外部引用目标的注销与释放由命令事务显式负责，本工具只维护
 * 关系容器，避免把领域解绑与对象资源生命周期隐式耦合。
 *
 * @param constraint 待永久解除的关系定义。
 * @returns 实际删除过关系的宿主数量。
 */
export function detachConstraintFromAllTargets(constraint: SketchRelationDefinition): number {
    const targets = constraint.getTargetsSnapshot();
    let detachedTargetCount = 0;

    targets.forEach((target) => {
        if (isSketchRelationContainer(target.constraints)
            && target.constraints.removeRelation(constraint.id)) {
            detachedTargetCount += 1;
        }
    });

    return detachedTargetCount;
}
